import { Alert, Button, Modal, Stack, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { useAuth } from "../Auth";


export interface LoginProps {
    opened: boolean;
    onClose: () => void;
}

const Login: React.FC<LoginProps> = ({ opened = true, onClose }) => {
    const {login} = useAuth();
    const [showSuccess, setShowSuccess] = useState(false);
    
    const loginForm = useForm({
        mode: 'uncontrolled',
        initialValues: {
            email: '',
        },
        validate: {
            email: (value) => {
                if (value.length === 0) {
                    return 'Email is required';
                }
                else if (!value.includes('@') || !value.includes('.')) {
                    return 'Email is invalid';
                }
                return null;
            },
        },
    });
    const handleLogin = (email: string) => {
        login({email});
        setShowSuccess(true);
    }
    const handleClose = () => {
        setShowSuccess(false);
        onClose();
    }

    const onFormError = () => {
        // console.log("Form validation errors:", loginForm.errors);    
    }
    const onFormSuccess = (values: typeof loginForm.values) => {
        const emailValue = values.email;
        handleLogin(emailValue);
    }
    return (
        <Modal
            title="Login"
            opened={opened}
            onClose={handleClose}
        >
            <Stack>
                <form onSubmit={loginForm.onSubmit(onFormSuccess, onFormError)}>
                    <Stack>
                        {showSuccess ? <Alert color="teal" title='Login Verification Step' icon={<IconCheck />}>
                            <Text>Check your email inbox! If an account associated with this email address is located, you will receive a magic login link via email. Click the magic link to complete the login process.</Text>
                        </Alert> :<Text>You will receive a magic link in your email that will take you to your dashboard!</Text>}
                        <TextInput readOnly={showSuccess} {...loginForm.getInputProps('email')} data-autofocus label="Email" placeholder="Enter your email" />
                        {!showSuccess && <Button type="submit">Login</Button>}
                    </Stack>
                </form>
            </Stack>

        </Modal>
    )
}

export default Login;